import dayjs from '@/utils/dayjs';
import { useMemo } from 'react';

export function useRelativeTime(date?: string | Date) {
    return useMemo(() => {
        if (!date) return '';

        const now = dayjs();
        const createdAt = dayjs(date);

        const diffSeconds = now.diff(createdAt, 'second');
        const diffMinutes = now.diff(createdAt, 'minute');
        const diffHours = now.diff(createdAt, 'hour');
        const diffDays = now.diff(createdAt, 'day');

        if (diffSeconds < 5) return 'agora';
        if (diffSeconds < 60) return `há ${diffSeconds} seg`;
        if (diffMinutes < 60) return `há ${diffMinutes} min`;
        if (diffHours < 24)
            return `há ${diffHours} ${diffHours === 1 ? 'hora' : 'horas'}`;
        if (diffDays <= 7)
            return `há ${diffDays} ${diffDays === 1 ? 'dia' : 'dias'}`;

        return createdAt.format('DD/MM/YYYY');
    }, [date]);
}
